export function create (tag = 'span') {
  return document.createElement(tag || 'div')
}

export function on (el, type, listeners, options = false) {
  if (!el || !type || !listeners) {
    return
  }

  el.addEventListener(type, listeners, options)
}

export function off (el, type, listeners, options = false) {
  if (!el || !type || !listeners) {
    return
  }

  el.removeEventListener(type, listeners, options)
}

export function get (selector = '') {
  return document.querySelector(selector)
}

export function getStyle (target = '', property = '') {
  let $dom = target

  if (typeof target === 'string') {
    $dom = get(target)
  }

  if (!$dom) {
    return
  }

  const style = getComputedStyle($dom)

  if (style) {
    return style[property]
  }
}

export function updateStyle (rules = '', id = '') {
  let $style

  if (id) {
    $style = get(`#${id}`)
  }

  if ($style) {
    $style.innerHTML = rules
  } else {
    $style = create('style')
    $style.id = id
    $style.type = 'text/css'
    $style.innerHTML = rules

    document.head.appendChild($style)
  }

  return $style
}
